import { PrimaryButton } from "office-ui-fabric-react/lib-commonjs";
import React, { Component } from "react";
import { Link } from "react-router-dom";

interface SchoolSubmissionAnalyticsNavigationProps {
    tenantId: string,
    schoolCode: string,
    current?: "overview" | "student" | "teacher" | "yearGroup" | "subject",
    startDate?: string,
    endDate?: string,
    academicYear: number
}

interface SchoolSubmissionAnalyticsNavigationState {

}

export default class SchoolSubmissionAnalyticsNavigation extends Component<SchoolSubmissionAnalyticsNavigationProps, SchoolSubmissionAnalyticsNavigationState>
{
    constructor(props: SchoolSubmissionAnalyticsNavigationProps) {
        super(props);
        this.state = {};
    }

    public render() {
        return (
            <div className={"submission-analytics-navigation"}>
                    <fieldset>
                        <legend>Assignment Data</legend>
                        <div className={"submission-analytics-navigation__links"}>
                            <Link to={`/manage/${this.props.tenantId}/${this.props.schoolCode}/assignment-analytics-overview?academicYear=${this.props.academicYear}&startDate=${this.props.startDate}&endDate=${this.props.endDate}`}>
                                <PrimaryButton
                                    text="Overview"
                                    checked={this.props.current === "overview"}
                                />
                            </Link>
                            <Link to={`/manage/${this.props.tenantId}/${this.props.schoolCode}/teacher-assignment-analytics?academicYear=${this.props.academicYear}&startDate=${this.props.startDate}&endDate=${this.props.endDate}`}>
                                <PrimaryButton
                                    text="Teachers"
                                    checked={this.props.current === "teacher"}
                                />
                            </Link>
                        </div>
                    </fieldset>
                
                
                <fieldset>
                    <legend>Submission Data</legend>
                    <div className={"submission-analytics-navigation__links"}>

                        <Link to={`/manage/${this.props.tenantId}/${this.props.schoolCode}/student-assignment-analytics?academicYear=${this.props.academicYear}&startDate=${this.props.startDate}&endDate=${this.props.endDate}`}>
                            <PrimaryButton
                                text="Students"
                                checked={this.props.current === "student"}
                            />
                        </Link>
                        <Link to={`/manage/${this.props.tenantId}/${this.props.schoolCode}/year-group-assignment-analytics?academicYear=${this.props.academicYear}&startDate=${this.props.startDate}&endDate=${this.props.endDate}`}>
                            <PrimaryButton
                                text="Year Groups"
                                checked={this.props.current === "yearGroup"}
                            />
                        </Link>
                        <Link to={`/manage/${this.props.tenantId}/${this.props.schoolCode}/subject-assignment-analytics?academicYear=${this.props.academicYear}&startDate=${this.props.startDate}&endDate=${this.props.endDate}`}>
                            <PrimaryButton
                                text="Subjects"
                                checked={this.props.current === "subject"}
                            />
                        </Link>
                    </div>
                </fieldset>
               
            </div>
        );
    }
}